import { mapGetters } from 'vuex'

export const authComputed = {
  ...mapGetters(['loggedIn']),
}

export function openApp(url, newtab = false) {
  if (newtab === true) window.open(url, '_blank')
  else window.location.href = url
}
